export const excludedRoutes = [
  "/redirect",
  "/conciliacao/redirect",
  "/conciliacao/registro-de-evidencia/",
  "/conciliacao/registro-de-nsu/",
  "/informations",
  "/sofia",
];